import React, { useEffect } from 'react';
import useI18n from 'hooks/use-i18n';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { Search } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import {
  getTextSearch,
  setTextSearch,
  getBadgeSearch,
  setBadgeSearch,
  getQuestionSearch,
  setQuestionSearch,
  setHeaderTextSearch,
} from 'store/search';
import PropsTypes from 'prop-types';

const SearchPagination = ({
  className,
  placeholder,
  badge,
  questionAvailable,
  reports,
}) => {
  const i18n = useI18n();
  const { query } = useRouter();
  const textSearch = useSelector(getTextSearch);
  const badgeSearch = useSelector(getBadgeSearch);
  const questionSearch = useSelector(getQuestionSearch);
  const dispatch = useDispatch();

  useEffect(() => {
    if (query?.textSearch) {
      dispatch(setTextSearch(query.textSearch));
    }
    return () => {
      dispatch(setTextSearch(''));
    };
  }, []);

  const handleChange = (e) => {
    questionAvailable
      ? dispatch(setQuestionSearch(e.target.value))
      : dispatch(setTextSearch(e.target.value));
    !questionAvailable && dispatch(setHeaderTextSearch(''));
  };

  return (
    <>
      <InputGroup
        className={`${
          className === 'announcement'
            ? `round input-group-merge header__input-group mx-0 pt-0 pb-0`
            : `input-group-merge header__input-group mx-0 pt-0 pb-0 ${className}`
        }`}
      >
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <Search size={14} />
          </InputGroupText>
        </InputGroupAddon>
        {badge ? (
          <Input
            placeholder={placeholder || i18n.t('header.search')}
            value={badgeSearch.trimStart()}
            onChange={(e) => dispatch(setBadgeSearch(e.target.value))}
          />
        ) : (
          <Input
            style={
              reports ? { padding: '15px 0rem' } : { padding: '1.3rem 0rem' }
            }
            placeholder={placeholder || i18n.t('header.search')}
            value={
              questionAvailable
                ? questionSearch.trimStart()
                : textSearch.trimStart()
            }
            onChange={handleChange}
          />
        )}
      </InputGroup>
    </>
  );
};

SearchPagination.prototype = {
  className: PropsTypes.string,
};

export default SearchPagination;
